import firebase from "firebase/app";
import "firebase/storage";

const ENV_API_KEY =
  process.env.REACT_APP_FIREBASE_API_KEY ||
  process.env.FIREBASE_API_KEY ||
  (typeof window !== "undefined" ? window.FIREBASE_API_KEY : undefined);

const firebaseConfig = {
  authDomain: "landing-gen-dev-25ef8.firebaseapp.com",
  databaseURL: "https://landing-gen-dev-25ef8.firebaseio.com",
  projectId: "landing-gen-dev-25ef8",
  storageBucket: "landing-gen-dev-25ef8.appspot.com",
  messagingSenderId: "221392219284",
  appId: "1:221392219284:web:255470c441466fb2079881",
  measurementId: "G-BNXC4XKF7C",
};

let storageInstance;
let initPromise;
let resolvedApiKey = ENV_API_KEY || "";

const fetchApiKeyFromServer = async () => {
  if (typeof window === "undefined" || !window.fetch) {
    return "";
  }

  try {
    const response = await window.fetch("/config/firebase", {
      credentials: "same-origin",
      cache: "no-store",
    });

    if (!response.ok) {
      return "";
    }

    const { apiKey } = await response.json();
    return apiKey || "";
  } catch (error) {
    console.error("Error fetching Firebase API key", error);
    return "";
  }
};

const initialiseFirebase = async () => {
  if (storageInstance) {
    return storageInstance;
  }

  if (initPromise) {
    return initPromise;
  }

  initPromise = (async () => {
    if (!resolvedApiKey) {
      resolvedApiKey = await fetchApiKeyFromServer();
    }

    if (!resolvedApiKey) {
      throw new Error("Firebase API key is missing");
    }

    if (!firebase.apps.length) {
      firebase.initializeApp({ ...firebaseConfig, apiKey: resolvedApiKey });
    }

    storageInstance = firebase.storage().ref();
    return storageInstance;
  })().catch((error) => {
    initPromise = undefined;
    throw error;
  });

  return initPromise;
};

export default initialiseFirebase;
